angular.module('public_app', [
    'iw.frontyard.repayment_calculator',
    'iw.frontyard.error',
    'iw.frontyard.signup'
]).config(function whiteListForIwocaCDN($sceDelegateProvider) {
    var sameOriginResource = 'self';
    var staticIwocaCDN = 'https://static.iwoca.com/**';

    $sceDelegateProvider.resourceUrlWhitelist([
        sameOriginResource,
        staticIwocaCDN
    ]);
});